/**
 * @file Select 下拉选择
 */
import SelectAntd from 'antd/es/select';
import { CountrySelect } from './CountrySelect';
import { NationalitySelect } from './NationalitySelect';
import { Segmented } from './Segmented';
import { SelectRaw } from './Select';
export const Select = SelectRaw;
Select.Option = SelectAntd.Option;
Select.OptGroup = SelectAntd.OptGroup;
Select.Country = CountrySelect;
Select.Nationality = NationalitySelect;
Select.Segmented = Segmented;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU2VsZWN0L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxVQUFVLE1BQU0sZ0JBQWdCLENBQUE7QUFFdkMsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGlCQUFpQixDQUFBO0FBQy9DLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLHFCQUFxQixDQUFBO0FBQ3ZELE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxhQUFhLENBQUE7QUFDdkMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLFVBQVUsQ0FBQTtBQWlCcEMsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLFNBQXlCLENBQUE7QUFDL0MsTUFBTSxDQUFDLE1BQU0sR0FBRyxVQUFVLENBQUMsTUFBTSxDQUFBO0FBQ2pDLE1BQU0sQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFFBQVEsQ0FBQTtBQUNyQyxNQUFNLENBQUMsT0FBTyxHQUFHLGFBQWEsQ0FBQTtBQUM5QixNQUFNLENBQUMsV0FBVyxHQUFHLGlCQUFpQixDQUFBO0FBQ3RDLE1BQU0sQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFBIn0=